import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import ngAnimate from 'angular-animate';
import overdrawnItemsTemplate from './OverdrawnItems.template.html';

export default angular
  .module('books.dialogs.OverdrawnItemsDialog', [
    csmCommonWeb,
    'ui.bootstrap',
    ngAnimate,
    'ui.grid'
  ])
  .service('OverdrawnItemsDialog', overdrawnItemsDialogService).name;

/*****************************************************************************
 * Service: OverdrawnItemsDialog
 *
 * Utility to display a dialog listing accounts that will be overdrawn before
 * saving a check.
 *****************************************************************************/
//@ngInject
function overdrawnItemsDialogService($q, $uibModal, uiGridConstants) {
  /***************************************************************************
   * Controller: OverdrawnItemsController */
  /**
   * Displays a grid of expense items that will cause their accounts to overdraw
   *
   * @param   items
   ***************************************************************************/
  /* @ngInject */
  function OverdrawnItemsController($scope, items) {
    $scope.items = items;

    /*--------------*/
    /* Grid options */
    /*--------------*/
    $scope.overdrawnGrid = {
      enableColumnMenus: false,
      enableSorting: true,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        $scope.overdrawnGrid.api = gridApi;
      },
      columnDefs: [
        { field: 'accountNumber', displayName: 'Number', maxWidth: 120 },
        { field: 'accountName', displayName: 'Name' },
        {
          field: 'balance',
          displayName: 'Current Balance',
          maxWidth: 170,
          cellFilter: 'currency'
        },
        {
          field: 'expectedBalance',
          displayName: 'Expected Balance',
          maxWidth: 170,
          cellFilter: 'currency'
        }
      ],
      data: items || []
    };
  }

  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog with the overdrawn items.
   *
   * @param  items      DGExpenseItems to look through
   * @return            Promise to listen on
   *****************************************************************************/
  this.show = function (items) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      resolve: {
        items: function () {
          return items;
        }
      },
      controller: OverdrawnItemsController,
      size: 'lg',
      template: overdrawnItemsTemplate
    }).result;
  };
}
